import React, { useRef } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Typography } from "antd";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";

import Gstr3BFilters from "./components/Gstr3BFilters";
import Section3_1 from "./components/Section3_1";
import Section3_1_1 from "./components/Section3_1_1";
import Section3_2 from "./components/Section3_2";
import Section4 from "./components/Section4";
import Section5 from "./components/Section5";

import {
  fetchSection31,
  fetchSection311,
  fetchSection32,
  fetchSection4,
  fetchSection5,
} from "./Gstr3BSummaryThunk";
import ReportDom from "../../../components/common/ReportDom";

const { Title } = Typography;

const GSTR3BSummary = () => {
  const reportRef = useRef();
  const dispatch = useDispatch();

  const { filters, loading } = useSelector((state) => state.gstr3b);

  // ✅ PRINT
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "GSTR-3B Summary",
  });

  // ✅ MAIN REPORT LOAD (ALL APIs)
  const handleReport = () => {
    if (!filters?.accId) return;

    Promise.all([
      dispatch(fetchSection31(filters)),
      // dispatch(fetchSection311(filters)),
      // dispatch(fetchSection32(filters)),
      dispatch(fetchSection4(filters)),
      dispatch(fetchSection5(filters)),
    ]);
  };

  const cardStyle = { marginBottom: 16 };

  return (
    <div style={{ padding: 16 }}>
      <App>
        {/* HEADER */}
        <Card
          style={{ marginBottom: 16 }}
          title={<Title level={4}>GSTR-3B Summary</Title>}
          extra={
            <Button icon={<PrinterOutlined />} onClick={handlePrint}>
              Print
            </Button>
          }
        />

        {/* FILTERS */}
        <div style={{ marginBottom: 16 }}>
          <Gstr3BFilters onReport={handleReport} />
        </div>

        {/* SECTIONS */}
        <Card style={cardStyle} loading={loading}>
          <Section3_1 />
        </Card>

        <Card style={cardStyle} loading={loading}>
          <Section3_1_1 />
        </Card>

        <Card style={cardStyle} loading={loading}>
          <Section3_2 />
        </Card>

        <Card style={cardStyle} loading={loading}>
          <Section4 />
        </Card>

        <Card style={cardStyle} loading={loading}>
          <Section5 />
        </Card>
      </App>

      {/* ✅ PRINT LAYOUT */}
      {/* ✅ PRINT LAYOUT (UPDATED) */}
      <div
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: "100%",
        }}
      >
        <ReportDom
          ref={reportRef}
          title="GSTR-3B Summary"
          filters={filters}
          showTotal={false} // IMPORTANT
          renderTable={() => (
            <>
              <div style={{ marginBottom: 16 }}>
                <Section3_1 printMode />
              </div>

              <div style={{ marginBottom: 16 }}>
                <Section3_1_1 printMode />
              </div>

              <div style={{ marginBottom: 16 }}>
                <Section3_2 printMode />
              </div>

              <div style={{ marginBottom: 16 }}>
                <Section4 printMode />
              </div>

              <div style={{ marginBottom: 16 }}>
                <Section5 printMode />
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
};

export default GSTR3BSummary;